<template>
  <b-modal :id="id" size="xl" button-size="sm" ref="modal" :title="prefix + title" hide-footer
    v-model="showTarefaRetiradaModal" @hidden="cancelar" @close="cancelar">
    <b-card bg-variant="light">
      <b-card>
        <div>
          <div style="font-size: 16px">
            <span v-for="(value, key, index) in headerTarefa" :key="index">
              <strong>{{ key }}:</strong> {{ value }} <br />
            </span>
          </div>
        </div>
      </b-card>
      <div style="font-size: 16px" class="headList">
        <p class="pList" v-for="(value, key, index) in tarefaToRender" :key="index">
          <span v-if="key !== 'check'">
            <strong>{{ key }}:</strong> {{ value }}
          </span>
          <b-form-checkbox v-else v-model="showEstoque">
            <span v-if="showEstoque">Ocultar Estoques</span>
            <span v-else>Visualizar Estoques</span>
          </b-form-checkbox>
        </p>
      </div>
      <div style="font-size: 16px" class="headList">
        <p class="pList">
          <strong>Justificativa</strong> {{ pedido.justificativa }}
        </p>
      </div>
      <b-table id="t-tarefa-item" responsive class="mt-2" small :items="itens" :fields="fieldsTabelaItens"
        :busy="this.busy">



        <template #cell(expand)="row">
          <b-button @click="row.toggleDetails" variant="primary" size="sm">{{ row.detailsShowing ? "-" : "+"
            }}</b-button>
        </template>

        <template #row-details="row">
          <b-row>
            <b-col cols="3">
              <span style="margin-left:40px">{{ row.item.lote }}</span>

            </b-col>
            <b-col cols="7">

            </b-col>

            <b-col cols="2" >
              <b-form-input  :disabled="isVisualizacao" type="number" v-model="row.item.quantidadeRetirada" min="0"
                required />

            </b-col>

          </b-row>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>


        <template #cell(estoque)="data">
          <span>{{ data.item.saldo - (data.item.quantidadeRetirada ? data.item.quantidadeRetirada : 0) }}</span>
        </template>
      </b-table>
      <b-col lg="12" sm="12" class="text-left">
        <b-form-group label-for="textarea-formatter" class="col-12">
          <label for="textarea-auto-height">Observação:</label>
          <b-form-textarea :disabled="isVisualizacao" id="textarea-formatter" v-model="observacao" :required="false">
          </b-form-textarea>
        </b-form-group>
      </b-col>
      <b-row class="text-center">
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <b-button v-if="!isVisualizacao" id="ConcluirAprAlmoxarif" variant="primary" size="sm" class="ml-2"
            @click="enviar">
            Concluir
            <b-tooltip target="ConcluirAprAlmoxarif" title="Prosseguir para a próxima tarefa"></b-tooltip>
          </b-button>
          <b-button id="cancelarAprAlmoxarif" variant="danger" size="sm" class="ml-2" @click="cancelar">
            Cancelar
            <b-tooltip target="cancelarAprAlmoxarif" title="Cancelar"></b-tooltip>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"

export default {
  data() {
    return {
      podeRealizarOperacaoSaldoNegativo: false,
      showTarefaRetiradaModal: true,
      itens: [],
      busy: false,
      tarefaToRender: {},
      headerTarefa: {},
      showEstoque: false,
      observacao: "",

    }
  },

  beforeMount() {
    this.$tarefaService = new ResourceService("/api/tarefaspedido")
    new ResourceService("/api/configuracoes-sistema/podeRealizarOperacaoQueTornemSaldoNegativo").find().then(response=>{
      this.podeRealizarOperacaoSaldoNegativo = response.data;
    });
    this.observacao = this.tarefa.observacao;
  },

  mounted() {
    this.load()
  },

  props: {
    id: Number,
    pedido: Object,
    tarefa: Object,
    uri: String,
    responsavel: Object,
    isVisualizacao: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tarefas",
    },
  },

  computed: {
    fieldsTabelaItens() {
      return [
        { key: 'expand', label: '', thClass: 'w-1', tdClass: 'w-1' },
        {
          key: "produto",
          label: "Lote",
        },
        {
          key: "saldo",
          label: "Estoque",
          thStyle: { width: "10%" },
          thClass: this.showEstoque ? "" : "d-none",
          tdClass: this.showEstoque ? "" : "d-none",
        },

        {
          key: "duracaoEstoqueAtual",
          label: "Duração Estoque",
          thStyle: { width: "10%" },
          thClass: this.showEstoque ? "" : "d-none",
          tdClass: this.showEstoque ? "" : "d-none",
        },
        {
          key: "quantidadeAprovada",
          label: "Aprovado",
          thStyle: { width: "10%" },
        },
        {
          key: "quantidadeRetiradaDoProduto",
          label: "Retirado",
          thStyle: { width: "10%" },
        },
        {
          key: "estoque",
          label: "Estoque Atual",
          thStyle: { width: "10%" },
          thClass: this.showEstoque ? "" : "d-none",
          tdClass: this.showEstoque ? "" : "d-none",
        },
      ]
    },
  },

  methods: {
    cancelar() {
      this.showTarefaRetiradaModal = false
      this.$emit("close")
    },
    formatarData(valor) {
      if (!valor) return ""

      const data = new Date(valor)
      const dia = data.getDate().toString().padStart(2, "0")
      const mes = (data.getMonth() + 1).toString().padStart(2, "0")
      const ano = data.getFullYear()
      const hora = data.getHours().toString().padStart(2, "0")
      const minutos = data.getMinutes().toString().padStart(2, "0")
      const segundos = data.getSeconds().toString().padStart(2, "0")

      return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`
    },

    async load() {
      this.busy = true;
      await this.$tarefaService
        .findById(`${this.tarefa.id}${this.uri}`)
        .then(response => {
          this.itens = response.data
          this.busy = false;

        });

      this.tarefaToRender = {
        Tarefa: this.tarefa.tipoTarefaPedido.descricao,
        Almoxarife: this.tarefa.pessoa?this.tarefa.pessoa.nome:"",
        check: this.showEstoque,
        Status: this.tarefa.status.descricao,
        "Responsavel Retirada": !this.isVisualizacao ? this.responsavel.nome : (this.tarefa.responsavelRetirada?this.tarefa.responsavelRetirada.nome:""),
      }
      this.headerTarefa = {
        NºPedido: this.pedido.id,
        Solicitante: this.pedido.departamentoSolicitante.descricao,
        Data: this.formatarData(this.tarefa.dataCriacao),
      }
    },

    async enviar() {
      try {

        if (this.itens.some(item => !item.quantidadeRetirada || item.quantidadeRetirada < 0)) {
          this.$notify({
            type: "danger",
            message: "Há divergência(s) nas quantidade(s) informada(s) para retirada.",
          });
          return;
        }


        if (this.itens.some(item => (!this.podeRealizarOperacaoSaldoNegativo) && item.quantidadeRetirada > item.saldo)) {
          this.$notify({
            type: "danger",
            message: "Há divergência(s) nas quantidade(s) informada(s) para retirada.",
          });
          return;
        }


        const itensRetirada = this.itens.map(
          ({ idProduto, quantidadeRetirada, codItemPedido, duracaoEstoqueAtual, quantidadeAprovada }) => {
            let item = {
              idProduto: idProduto,
              idAlmoxarifado: this.tarefa.almoxarifado.id,
              codTarefaPedido: this.tarefa.id,
              codItemPedido: codItemPedido,
              quantidadeRetiradaLote: quantidadeRetirada,
              quantidadeAprovada: quantidadeAprovada,
              duracaoEstoqueAtual:
                duracaoEstoqueAtual,
            }
            return item;
          }
        );

        this.busy = true;

        await this.$tarefaService
          .put(`executaProximaTarefaRetirada`, {
            id: this.tarefa.id,
            pedido: this.pedido,
            itensRetirada,
            observacao: this.observacao,
            responsavelRetirada: this.responsavel,
            almoxarifado: this.tarefa.almoxarifado,
          })
          .then(() => {
            this.busy = false;
            this.$notify({
              type: "success",
              message: "Tarefa finalizada com sucesso",
            })
            this.showTarefaRetiradaModal = false
            this.$emit("tarefaRetiradaFinalizado", {})
          })
      } catch (e) {

        this.busy = false;

        this.$notify({
          type: "danger",
          message: e.message || e,
        })
      }
    },
  },
}
</script>
<style>
.headList {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.pList {
  flex: 0 0 calc(33.3% - 11px);
}
</style>
